module.exports = "<app-deck></app-deck>\n\n\n\n"